import Pagination from '@/util/pagination'
import { formatDate } from '@/util/helpers'

export default function () {
  return {
    invites: [],
    pagination: new Pagination(),
    formatDate,
  }
}
